export default class TabInfo {
  constructor(name, label, routePath) {
    this.name = name;
    this.label = label;
    this.routePath = routePath;
  }
}
